<template>
  <div class="back-btn fc" @click="handleGoBotView" data-testid="components-backhome-go-bot-view">
    <svg-icon name="home" padding="0" :size="18" />
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import { getLastConversationIdApi } from '@api/chat';

export default defineComponent({
  props: {
    botId: {
      type: String
    }
  },
  setup(props) {
    const router = useRouter();
    const handleGoBotView = async () => {
      const jump_id = props.botId;

      if (!jump_id) {
        router.push({
          path: '/workspace'
        });
        return;
      }
      const res = await getLastConversationIdApi({
        robot_id: jump_id
      });
      router.push({
        path: '/botView',
        query: {
          id: props.botId,
          sessionId: res.last_segment_code
        }
      });
    };
    return {
      handleGoBotView
    };
  }
});
</script>

<style scoped lang="less">
.back-btn {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  vertical-align: middle;
  background: 0;
  color: var(--font-color);
  position: absolute;
  top: 28px;
  right: 32px;
  border: 1px solid var(--border-neutral-color-secondary);
  &:hover {
    background-color: var(--dark-btn-outline-hover-color);
    cursor: pointer;
  }
}
</style>
